import type { LoadingState } from 'reactApp/types/commonStates';

export enum BillingBuyTemplates {
    CHECKOUT_VKPAY = 'CHECKOUT_VKPAY',
    CHECKOUT_VKPAY_NOOFFER = 'CHECKOUT_VKPAY_NOOFFER',
    VK_WALLET_V2 = 'VK_WALLET_V2',
}

export enum MidasPlatform {
    mobile = 'mobile',
    desktop = 'desktop',
    tablet = 'tablet',
}

export type CommonBuyApiParams = {
    skin?: BillingBuyTemplates;
    source?: string;
    hide_pay_methods_menu?: boolean;
    hide_header?: boolean;
    hide_login_button?: boolean;
    hide_close_button?: boolean;
    description?: string;
    fullscreen?: boolean;
    theme?: string;
    view_platform?: MidasPlatform;
    // tempexp_18086-next-line
    ref_code?: string;
    view?: string;
};

export type BuyApiParams = CommonBuyApiParams & {
    product_id: string;
};

export type FreemiumApiParams = CommonBuyApiParams & {
    product_id: string;
    action?: string;
};

export type RenewApiParams = CommonBuyApiParams & {
    sub_id: string;
};

export type State = {
    link: string;
    renewLink: string;
    requestId: string;
    renewalCost?: number;
    freemiumIsLoading: boolean;
    freemiumIsLoaded: boolean;
} & LoadingState;

export type SetLinkAction = {
    link: string;
    requestId: string;
};

export type SetRenewalCostAction = {
    renewalCost: number;
    requestId: string;
};

export type HasErrorAction = {
    requestId: string;
};

export type StartLoadingAction = {
    requestId: string;
};

export type BuyAction = {
    id: string;
    isMobile?: boolean;
    payMethod?: string;
    source?: string;
    paySource?: string;
    xraySource?: string;
    isMidas?: boolean;
    description?: string;
    hidePayMethods?: boolean;
};
